var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2777_5772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 10.3333H7.33301V6.33333H8.66634M8.66634 13H7.33301V11.6667H8.66634M7.99967 3C7.1242 3 6.25729 3.17244 5.44845 3.50747C4.63961 3.8425 3.90469 4.33356 3.28563 4.95262C2.03539 6.20286 1.33301 7.89856 1.33301 9.66667C1.33301 11.4348 2.03539 13.1305 3.28563 14.3807C3.90469 14.9998 4.63961 15.4908 5.44845 15.8259C6.25729 16.1609 7.1242 16.3333 7.99967 16.3333C9.76778 16.3333 11.4635 15.631 12.7137 14.3807C13.964 13.1305 14.6663 11.4348 14.6663 9.66667C14.6663 8.79119 14.4939 7.92428 14.1589 7.11544C13.8238 6.30661 13.3328 5.57168 12.7137 4.95262C12.0947 4.33356 11.3597 3.8425 10.5509 3.50747C9.74206 3.17244 8.87515 3 7.99967 3Z",
    fill: "#8E6A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2777_5772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.be1de59ccc5b74a43cb31a18c2795a94.svg";
export { ForwardRef as ReactComponent };